module.exports = __webpack_public_path__ + "application/templates/default/inner/publications/publications.template.html";